import Image from "next/image";

import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { APP_SIZE, HEADER_SIZE } from "@styles/variables";
import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";

export const BOTTOM_BUTTON_HEIGHT = 80;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${HEADER_SIZE.HEIGHT}px 0 ${BOTTOM_BUTTON_HEIGHT}px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
`;

export const ImageContent = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
`;

export const BottomButtonBox = styled.div<{ $shouldFixSafeArea?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 50%;

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: auto;
  margin-top: auto;
  padding: 16px;

  border-top: 1px solid ${grayScale.main};

  background: ${getOpacityColor(grayScale[200], 0.7)};

  transform: translateX(-50%);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
`;

export const StyledButton = styled(motion.button)<{
  $bgColor?: string;
  $textColor?: string;
  $borderColor?: string;
}>`
  width: 100%;
  padding: 13px 16px;
  border: 1px solid ${({ $borderColor }) => $borderColor || "transparent"};
  border-radius: 8px;

  background-color: ${({ $bgColor }) => $bgColor || pink.main};

  color: ${({ $textColor }) => $textColor || grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
`;
